export default __webpack_public_path__ + "static/media/LSP3.32ae9104.jpeg";